import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { RestComponent } from '../../lib/RestComponent';
import { isPlainObject } from '../../lib/helpers';
import { SubscriptionLike } from 'rxjs';
import { CatalogItem, CatalogService } from '../catalog.service';
import { CatalogSection, CatalogSectionService } from '../../catalog-section.service';
import { SmartFilterItem, CatalogFilterService } from '../../catalog-filter.service';
import { BreadCrumbsService } from '../../breadcrumbs.service';
import { defaultNavParams, defaultOrder } from '../../catalog-items-default.component';
import { FilterService } from '../../filter.service';
import { CookieService } from 'ngx-cookie';
import { ConsultService } from '../../consult.service';
import { NotificationService } from '../../notification.service';
import { CityService } from '../../city.service';
import $ from '../../lib/jquery';

@Component({
  selector: 'catalog-section',
  templateUrl: './catalog-section.component.html',
  styleUrls: ['./catalog-section.component.less']
})
export class CatalogSectionComponent extends RestComponent implements OnInit, OnDestroy {
  section: CatalogSection;
  h1Text: string = '';
  catalog: CatalogItem[] = [];
  filterProperties: SmartFilterItem[] = [];
  navParams: any = defaultNavParams;
  order: any = defaultOrder;
  filter: any = {ACTIVE: 'Y'};
  isPaginationReady: boolean = false;
  isCatalogReady: boolean = false;

  activeSort: any = {name: null, value: null};
  countPages: number = 0;
  subscriptionFilter: SubscriptionLike;
  @ViewChild('catalogTitle', { static: false }) catalogTitleRef: ElementRef;

  constructor(
    private catalogService: CatalogService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private metaService: Meta,
    private breadCrumbsService: BreadCrumbsService,
    public filterService: FilterService,
    private sectionService: CatalogSectionService,
    private catalogFilterService: CatalogFilterService,
    private cookie: CookieService,
    private consult: ConsultService,
    private notificationService: NotificationService,
    private cityService: CityService,
  ) {
    super();
  }

  public ngOnInit() {
    var titleText: string;
    var descriptionText: string;

    this.subscription = this.route.params.subscribe(async (params) => {
      if (!params.code) return this.router.navigate(['/404']);

      const regionId = this.route.snapshot.pathFromRoot[0].pathFromRoot[0].firstChild.params['id'];

        if (regionId) {
          this.cityService.city = await this.cityService.get({
              filter: {CODE: regionId}
            }
          ).then(cities => cities[0]);
        }

      let filterTagObj = {};
      this.isPaginationReady = false;
      this.isCatalogReady = false;
      // reset current page
      this.navParams.iNumPage = 1;

      const activeTarget = this.cookie.get('target');
      const activeActivity = this.cookie.get('activity');
      const targetArr: string[] = [];
      if (activeTarget) targetArr.push(activeTarget);
      if (activeActivity) targetArr.push(activeActivity);
      
      try {
        this.section = await this.sectionService.getByCode(params.code);
        if (this.section.UF_PARENT_SECTION === null) {
          this.section.UF_PARENT_SECTION ='';
        }

        if (params.filterTag) {
          var filterTag = this.section.UF_FILTER_TAGS.find((tag) => tag.CODE === params.filterTag);
          let testFilterTagObj;
          try {
            testFilterTagObj = JSON.parse(filterTag.PROPERTY_JSON);
          } catch (e) {
            throw new Error('property PROPERTY_JSON not contain valid JSON string');
          }
          if (isPlainObject(testFilterTagObj)) filterTagObj = testFilterTagObj;
          else throw new Error('property PROPERTY_JSON not contain plain object');

          this.section.DESCRIPTION = filterTag.DETAIL_TEXT;
		  
		  if(this.cityService.city.PROPERTY_INFLECTED_VALUE == 'России') {
			  this.h1Text = `${filterTag.NAME}`;
			  titleText = `Купить ${filterTag.NAME} - Золотой код`;
			  descriptionText = `Купить ${filterTag.NAME} для автоматизации Вашего бизнеса. Компания Золотой код`;
		  }
		  else {
			  this.h1Text = `${filterTag.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
			  titleText = `Купить ${filterTag.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE} - Золотой код`;
			  descriptionText = `Купить ${filterTag.NAME} для автоматизации Вашего бизнеса. Компания Золотой код в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
		    
		  }

        }else if (this.section.IBLOCK_ROOT_SECTION_ID === '26') {
			
			if(this.cityService.city.PROPERTY_INFLECTED_VALUE == 'России') {

			  titleText = `Купить ${this.section.NAME} ${this.section.UF_PARENT_SECTION} - Золотой код`;
			  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код`;
			  this.h1Text = `${this.section.NAME} ${this.section.UF_PARENT_SECTION}`;
				
				if (this.section.ID === '314') {

				  titleText = `Купить Обучение работе с сайтом - Золотой код`;
				  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код`;
				  this.h1Text = `Обучение работе с сайтом`;
				  
				}
			}
			else {
				
			  titleText = `Купить ${this.section.NAME} ${this.section.UF_PARENT_SECTION} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE} - Золотой код`;
			  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
			  this.h1Text = `${this.section.NAME} ${this.section.UF_PARENT_SECTION} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				
				if (this.section.ID === '314') {

				  titleText = `Купить Обучение работе с сайтом в ${this.cityService.city.PROPERTY_INFLECTED_VALUE} - Золотой код`;
				  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				  this.h1Text = `Обучение работе с сайтом в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				  
				}

			}
		  
        }else{
			if(this.cityService.city.PROPERTY_INFLECTED_VALUE == 'России') {
				
				titleText = `Купить ${this.section.NAME} - Золотой код`;
				descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код`;
				
				this.h1Text = `${this.section.NAME}`;
				
				if (this.section.ID === '111') {

				  titleText = `Купить Автоматизация фитнес клубов - абонементы - Золотой код`;
				  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код`;
				  this.h1Text = `Автоматизация фитнес клубов - абонементы`;
				}
				
			}
			else {
				titleText = `Купить ${this.section.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE} - Золотой код`;
				descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				
				this.h1Text = `${this.section.NAME} в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				
				if (this.section.ID === '111') {

				  titleText = `Купить Автоматизация фитнес клубов - абонементы в ${this.cityService.city.PROPERTY_INFLECTED_VALUE} - Золотой код`;
				  descriptionText = `Купить ${this.section.NAME} для автоматизации Вашего бизнеса. Компания Золотой код в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				  this.h1Text = `Автоматизация фитнес клубов - абонементы в ${this.cityService.city.PROPERTY_INFLECTED_VALUE}`;
				}
				
			}
        }
		
		

        this.filter = Object.assign(filterTagObj, {ACTIVE: 'Y', 'PROPERTY_TAGS.XML_ID': targetArr, 'IBLOCK_SECTION_ID': this.section.ID});

        this.catalog = await this.catalogService.get({
          order: this.order,
          filter: this.filter,
          navParams: this.navParams
        });
        this.isCatalogReady = true;

        const countItems = await this.catalogService.getCount({
          filter: this.filter
        });
        this.countPages = Math.ceil(countItems.count / this.navParams.nPageSize);
        setTimeout(() => { this.isPaginationReady = true; }, 100);

        this.titleService.setTitle(titleText);
        this.metaService.updateTag({name: 'description', content: descriptionText});

        this.breadCrumbsService.create([{
          name: this.section.NAME,
          color: 'general-primary'
        }]);
      } catch (e) {
        if (typeof window !== 'undefined') {
          this.consult.notification({
            name: 'Ошибка в соединении. Попробуйте повторить запрос',
            status: 'danger',
            createdAt: (new Date()).toISOString(),
            isReaded: false
          });
        }

        console.error(e.message);
        return false;
      }

      try {
        this.filterProperties = await this.catalogFilterService.getItems(this.section.ID);
      } catch (err) {
        this.filterProperties = [];
      }
    });

    this.subscriptionFilter = this.filterService.changeActive.subscribe((target: any) => {
      const targetArr: string[] = [];
      if (this.filterService.activeTargetAudience) targetArr.push(this.filterService.activeTargetAudience._id);
      if (this.filterService.activeActivity) targetArr.push(this.filterService.activeActivity._id);
      this.changeFilter({'PROPERTY_TAGS.XML_ID': targetArr});
    });
  }

  public ngOnDestroy() {
    defaultNavParams.iNumPage = 1;
    this.subscriptionFilter.unsubscribe();
    this.subscription.unsubscribe();
  }

  public async changeOrder(sort: any) {
    this.order = sort;
    this.isPaginationReady = false;
    this.resetList();
    await this.loadPage();
    this.isPaginationReady = true;
  }

  private resetPropFilter() {
    for (const key in this.filter) {
      if (this.filter.hasOwnProperty(key) && key.startsWith('=PROPERTY_')) {
        delete this.filter[key];
      }
    }
  }

  public async changeFilter(filter: object) {
    if (filter.hasOwnProperty('><CATALOG_PRICE_1')) this.resetPropFilter();
    this.filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), filter);
    this.isPaginationReady = false;

    let countItems: {count: number};
    try {
      countItems = await this.catalogService.getCount({
        filter: this.filter
      });
    } catch (e) {
      countItems = {count: 0};
    }

    this.countPages = Math.ceil(countItems.count / this.navParams.nPageSize);

    this.resetList();
    await this.loadPage();
    this.isPaginationReady = true;

    this.notificationService.show({
      message: `Найдено ${countItems.count} товаров`,
      status: 'success'
    });
  }

  public async changePage(page: number) {
    this.navParams.iNumPage = page;
    await this.loadPage();
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        $('html, body').animate({scrollTop: (this.catalogTitleRef.nativeElement.offsetTop - 70)}, 1000);
      }, 700);
    }
  }

  public async loadPage() {
    this.isCatalogReady = false;
    this.loadingState = true;
    try {
      const items: CatalogItem[] = await this.catalogService.get({
        order: this.order,
        filter: this.filter,
        navParams: this.navParams
      });

      this.catalog = items;

      this.loadingState = false;
      this.isCatalogReady = true;

      return this.catalog;
    } catch (err) {
      this.error = true;
      this.consult.notification({
        name: 'Ошибка в соединении. Попробуйте повторить запрос',
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.loadingState = false;
    }

  }

  private resetList() {
    this.navParams.iNumPage = 1;
  }
}
